import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/TaxExport/TaxExportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class TaxExportActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/TaxExport/TaxExport")
	}

	render() {
		return (
			<Activity 
				name="TaxExport"
				RenderedComponent={this.RenderedComponent}
				context="TaxExport"
				action="TaxExport"
                formActions={FormAction}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(TaxExportActivity)
